module.exports = __webpack_public_path__ + "static/img/ls6.084df72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/ls6.png
// module id = M93W
// module chunks = 12